<template>
  <autocomplete v-model="searchQuery" :options="options" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :required="required">
    <div slot="item" slot-scope="props" class="single-item">
      <span v-translate="{data: props.item.id}">ID: %{data}</span><br>
      <span v-translate="{data: props.item.reference}">Vehicle Reference: %{data}</span><br>
      <span v-translate="{data: props.item.plate_number}">Plate Number: %{data}</span><br>
      <span v-translate="{data: props.item.vehicle_type.name}">Type: %{data}</span>
    </div>
  </autocomplete>
</template>
<script>
import Autocomplete from '@/components/autocompletes/Autocomplete'

export default {
  name: 'VehicleAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    includes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      }
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Vehicle Reference or Plate Number')
    }
  },
  methods: {
    onInputChange(query) {
      let params = {
        includes: [...this.includes, 'vehicle_type'],
        sort: [
          {
            key: 'vehicle_type_id',
            direction: 'asc'
          },
          {
            key: 'plate_number',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['reference', 'ct', query.trim()],
              ['plate_number', 'ct', query.trim()]
            ]
          }
        ]
      }
      // if (!this.$cookies.get('bypassCountry')) {
      //   params.filter_groups.push(
      //     {
      //       filters: [
      //         ['country_iso_code', 'eq', window.country]
      //       ]
      //     }
      //   )
      // }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'vehicles', {params: params})
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}

</script>
<style lang="scss">
.v-suggestions {
  width: 100%;

  &:before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    background: transparent url(../../assets/img/ic-autocomplete-search.svg) no-repeat 50% 50%;
    background-size: contain;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%)
  }

  input {
    padding-left: 30px;
  }

  .items {
    .item {

      &.is-active,
      &:hover {
        background: rgba(0, 180, 255, 0.15) !important;
      }
    }
  }
}

</style>
